module.exports = __webpack_public_path__ + "img/rewards.0447fe65.svg";